import type { AuthorizedResourceAccessMap } from './adapter';

export const buildPermissionKey = (resourceCode: string, actionCode: string) =>
  `${resourceCode}:${actionCode}`;

export const hasResourceAccess = (
  access: AuthorizedResourceAccessMap | undefined,
  resourceCode: string,
) => Boolean(access?.[resourceCode]);

export const hasActionAccess = (
  access: AuthorizedResourceAccessMap | undefined,
  resourceCode: string,
  actionCode: string,
) => Boolean(access?.[buildPermissionKey(resourceCode, actionCode)]);
